import { styled } from "@mui/material";
import { Text } from "@totalenergiescode/mobility-business-rev-design-system";

const FONT_FAMILY = "'Roboto', sans-serif";

export const StyledTemplatePreview = styled("div")`
  font-family: ${FONT_FAMILY};
  background-color: ${({ theme }) => theme.palette.grey[100]};
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  border: 1px solid ${({ theme }) => theme.palette.grey[200]};
`;

export const StyledPreviewHeader = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const StyledPreviewTitle = styled(Text)`
  font-family: ${FONT_FAMILY};
  font-weight: 600;
`;

export const StyledCategoryBadge = styled("span")`
  font-family: ${FONT_FAMILY};
  background-color: ${({ theme }) => theme.palette.success.main};
  color: ${({ theme }) => theme.palette.white};
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
`;

export const StyledPreviewGrid = styled("div")`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
`;

export const StyledPreviewItem = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const StyledPreviewLabel = styled("span")`
  font-family: ${FONT_FAMILY};
  font-size: 12px;
  color: ${({ theme }) => theme.palette.grey[500]};
  font-weight: 500;
`;

export const StyledPreviewValue = styled("span")`
  font-family: ${FONT_FAMILY};
  font-size: 14px;
  color: ${({ theme }) => theme.palette.grey[900]};
  font-weight: 400;
`;

export const StyledUnavailableBanner = styled("div")`
  font-family: ${FONT_FAMILY};
  background-color: ${({ theme }) => theme.palette.warning.light};
  border: 1px solid ${({ theme }) => theme.palette.warning.main};
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 12px;
  color: ${({ theme }) => theme.palette.warning.dark};
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
`;

export const StyledLoadButton = styled("div")`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
`;

export const StyledLoadWarningText = styled("p")`
  width: 100%;
  text-align: right;
  font-family: ${FONT_FAMILY};
  font-size: 12px;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-weight: 500;
`;
